import utagLinkGeneric from './utagLinkGeneric';

function utagLinkSort (eventCategory = 'Sort') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		window.setTimeout(() => {

			utagLinkGeneric({
				eventCategory,
				eventAction,
				eventLabel,
				nonInteraction
			});

		}, 0);

	};

}

export default utagLinkSort;
